import { render, staticRenderFns } from "./ModalError.vue?vue&type=template&id=19d7534c&scoped=true&"
import script from "./ModalError.vue?vue&type=script&lang=js&"
export * from "./ModalError.vue?vue&type=script&lang=js&"
import style0 from "./ModalError.vue?vue&type=style&index=0&id=19d7534c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d7534c",
  null
  
)

export default component.exports